import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import Modal from 'antd/lib/modal';
import { translate } from 'react-i18next';
import { connectModal } from '../../../../features/modal/hoc';
import { apiCallIds } from '../../api';

@translate()
@connectModal(apiCallIds.ACCEPT_ACCOUNT_DOCUMENTS)
export default class AcceptDocumentsModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    const { t, children, modalActions, isVisible, isLoading, onSubmit } = this.props;

    return (
      <span>
        {cloneElement(children, { onClick: modalActions.show })}
        <Modal
          title={t('Schválenie občianskeho preukazu')}
          okText={t('Schváliť')}
          visible={isVisible}
          confirmLoading={isLoading}
          onOk={onSubmit}
          onCancel={modalActions.hide}
        >
          <p>{t('Pozor, skontroluj údaje v Detaile a v Profile podľa občianskeho preukazu.')}</p>
        </Modal>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/components/documents/AcceptDocumentsModal.js